// dataStore.js (Pinia store)
import { defineStore } from "pinia";
import { ref } from "vue";

function extractCleanSizeName(rawSize) {
    if (!rawSize) return "";
    if (typeof rawSize === "string") {
        if (rawSize.trim().startsWith("{")) {
            try {
                const parsed = JSON.parse(rawSize);
                return extractCleanSizeName(parsed);
            } catch {
                return "";
            }
        }
        const trimmed = rawSize.trim();
        if (trimmed === "سادە" || trimmed === "نرخ" || trimmed === "Normal" || trimmed === "Default") return "";
        return trimmed;
    }
    if (typeof rawSize === "object") {
        if (rawSize.name) {
            return extractCleanSizeName(rawSize.name);
        }
        const str = rawSize.ku || rawSize.ar || rawSize.en || "";
        if (typeof str === "string") {
            const trimmed = str.trim();
            if (trimmed === "سادە" || trimmed === "نرخ" || trimmed === "Normal" || trimmed === "Default") return "";
            return trimmed;
        }
    }
    return "";
}

function sanitizeOrders(raw) {
    if (!raw || typeof raw !== "object") return {};
    const cleaned = {};
    Object.entries(raw).forEach(([k, v]) => {
        if (v && typeof v === "object") {
            cleaned[k] = {
                ...v,
                size: extractCleanSizeName(v.size),
            };
        }
    });
    return cleaned;
}

export const useDataStore = defineStore("DataStore", () => {
    const isDataFetched = ref(false);
    const isJoinFetched = ref(false);
    const totalPrice = ref(0);
    const totalExpense = ref(0);
    const topItems = ref(null);
    const allItems = ref(null);
    const category = ref(null);
    const joinData = ref([]);
    const orders = ref(sanitizeOrders(JSON.parse(localStorage.getItem("order")) ?? {}));

    async function setOrders(data) {
        orders.value = sanitizeOrders(data);
    }
    async function prosTotal() {
        totalPrice.value = 0;
        Object.entries(orders.value).forEach(([key, value]) => {
            totalPrice.value += value.price * value.qty;
        });
        localStorage.setItem("order", JSON.stringify(orders.value));
    }
    function findOrder(id) {
        if (orders.value != null && orders.value[id]) {
            return true;
        }
        return false;
    }

    async function ToOrder(size, qty = 1, item, flavors = []) {
        const itemName = typeof item === "object" ? (item.ku || item.name || "") : (item || "");
        
        let flavorSuffix = "";
        let flavorExtraPrice = 0;
        let flavorText = "";

        if (flavors && flavors.length > 0) {
            const activeFlavors = flavors.filter((f) => f.qty > 0);
            if (activeFlavors.length > 0) {
                const flavorKeyParts = activeFlavors
                    .map((f) => `${f.name}_${f.qty}`)
                    .sort()
                    .join("_");
                flavorSuffix = "_f_" + flavorKeyParts;
                flavorExtraPrice = activeFlavors.reduce(
                    (sum, f) => sum + (Number(f.price) || 0) * (Number(f.qty) || 1),
                    0
                );
                flavorText = activeFlavors
                    .map((f) => `${f.name} (${f.qty})`)
                    .join("، ");
            }
        }

        const orderKey = size.id + flavorSuffix;
        const cleanSize = extractCleanSizeName(size.size);

        if (typeof orders.value[orderKey] === "undefined") {
            orders.value[orderKey] = {
                id: orderKey,
                name: itemName || size.name || "",
                size: cleanSize,
                flavors: flavors && flavors.length > 0 ? flavors.filter((f) => f.qty > 0) : null,
                flavorText: flavorText,
                item_id: size.item_id,
                size_id: size.size_id,
                qty: qty,
                price: flavorExtraPrice > 0 ? flavorExtraPrice : (Number(size.price) || 0),
                cost: size.cost || 0,
                comment: "",
            };
        } else {
            if (qty === 1) {
                orders.value[orderKey].qty += qty;
            } else {
                if (orders.value[orderKey].qty > 1) {
                    orders.value[orderKey].qty += qty;
                } else {
                    delete orders.value[orderKey];
                }
            }
        }
        prosTotal();
    }

    async function fetchData() {
        if (!isDataFetched.value) {
            axios
                .post(route("orders.get_all_items"), { id: 1 })
                .then((response) => {
                    allItems.value = response.data.allItems;
                    isDataFetched.value = true;
                });
        }
    }
    async function changeTotalPrice(price = 0) {
        totalPrice.value = price;
    }
    async function changeTotalExpense(price = 0) {
        totalExpense.value = price;
    }
    async function fetchJoinData(table = "calling") {
        if (!isJoinFetched.value) {
            try {
                const response = await axios.post(route("join.data"), {
                    table: table,
                });

                // Fix: Directly assign to the ref
                joinData.value = response.data.joinData || []; // Add fallback

                // console.log("joinData updated:", joinData.value);
                isJoinFetched.value = true;
            } catch (error) {
                console.error("Error fetching join data:", error);
                joinData.value = []; // Reset on error
            }
        }
    }

    return {
        category,
        allItems,
        fetchData,
        isDataFetched,
        joinData,
        orders,
        findOrder,
        prosTotal,
        ToOrder,
        setOrders,
        fetchJoinData,
        changeTotalPrice,
        totalPrice,
        topItems,
        changeTotalExpense,
        totalExpense,
    };
});
